module.exports = __webpack_public_path__ + "img/indethuisstudio@small.ba7372fc.jpg";